import { render } from "./StageBadge.vue?vue&type=template&id=60a08ff4"
import script from "./StageBadge.vue?vue&type=script&lang=js"
export * from "./StageBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__